import React from 'react';
import { UserCompetencies } from 'views/shared/UserCompetencies';
import { UserCycle } from 'views/availability/UserCycle';
import { Leave } from 'views/availability/Leave';
import { UserProfile, UserTravel } from 'views/Users';
import { ICal } from 'views/shared';
import AccountInput from '../input';

const config = {
  // General
  emptyMessage: 'Please select a User',
  title: 'User',
  tabItems: [
    {
      key: 0,
      title: 'Account',
      component: props => (
        <AccountInput
          {...props}
          title="User"
        />
      )
    },
    {
      key: 1,
      title: 'Profile',
      component: props => (
        <UserProfile
          {...props}
          title="Profile"
        />
      )
    },
    {
      key: 2,
      title: 'Roster',
      component: props => (
        <ICal
          {...props}
          title="Profile"
        />
      )
    },
    {
      key: 3,
      title: 'Availability',
      component: props => (
        <UserCycle
          {...props}
          title="Availability"
        />
      )
    },
    {
      key: 4,
      title: 'Leave',
      component: props => (
        <Leave
          {...props}
          title="Leave"
        />
      )
    },
    {
      key: 5,
      title: 'Travel',
      component: props => (
        <UserTravel
          {...props}
          title="Travel"
        />
      )
    },
    {
      key: 6,
      title: 'Competencies',
      component: props => (
        <UserCompetencies
          {...props}
          title="Competencies"
        />
      )
    }
  ]
};

export default config;
